(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/printable-coupon/assets/javascripts/printable-coupon.js') >= 0) return;  svs.modules.push('/components/pool-betting/printable-coupon/assets/javascripts/printable-coupon.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _svs$components$poolB = svs.components.poolBetting.printableCouponRow,
  PrintableCouponRow = _svs$components$poolB.PrintableCouponRow,
  PrintableCouponRowOutcomePairs = _svs$components$poolB.PrintableCouponRowOutcomePairs;
const PrintableCouponHeader = () => React.createElement("div", {
  className: "pb_print_coupon__header"
}, React.createElement("div", null), React.createElement("div", {
  className: "pb_print_coupon__header__participants"
}, "Deltagare"), React.createElement("div", {
  className: "pb_print_coupon__header__match_start"
}, "Matchstart"), React.createElement("div", null));
const PrintableCouponHeaderWithOutcomes = () => React.createElement("div", {
  className: "pb_print_coupon__header pb_print_coupon__header--outcome_pairs"
}, React.createElement("div", null), React.createElement("div", {
  className: "pb_print_coupon__header__participants"
}, "Deltagare"), React.createElement("div", {
  className: "pb_print_coupon__header__match_start"
}, "Matchstart"));
const groupOutcomePairs = outcomePairs => outcomePairs.map(arr => {
  const homeWins = [];
  const draws = [];
  const awayWins = [];
  arr.forEach(pair => {
    const _pair$map = pair.map(Number),
      _pair$map2 = _slicedToArray(_pair$map, 2),
      left = _pair$map2[0],
      right = _pair$map2[1]; 
    if (left > right) {
      homeWins.push(pair);
    } else if (left === right) {
      draws.push(pair);
    } else {
      awayWins.push(pair);
    }
  });
  return [homeWins, draws, awayWins];
});
const PrintableCoupon = _ref => {
  let draw = _ref.draw,
    _ref$outcomePairs = _ref.outcomePairs,
    outcomePairs = _ref$outcomePairs === void 0 ? [] : _ref$outcomePairs,
    _ref$participants = _ref.participants,
    participants = _ref$participants === void 0 ? [] : _ref$participants,
    _ref$signs = _ref.signs,
    signs = _ref$signs === void 0 ? [] : _ref$signs,
    reductions = _ref.reductions;
  const hasOutcomePairs = outcomePairs.length > 0;
  const _ref2 = draw || {},
    matchCount = _ref2.matchCount,
    eventCount = _ref2.eventCount,
    productId = _ref2.productId;
  const hasPeriods = matchCount === 1 && eventCount > 1;
  return React.createElement("div", {
    className: "pb_print_coupon"
  }, hasOutcomePairs ? React.createElement(PrintableCouponHeaderWithOutcomes, null) : React.createElement(PrintableCouponHeader, null), draw === null || draw === void 0 ? void 0 : draw.drawEvents.map((drawEvent, index) => {
    if (hasOutcomePairs) {
      var _outcomePairs$index, _groupOutcomePairs;
      return React.createElement(PrintableCouponRowOutcomePairs, {
        drawEvent: drawEvent,
        hasPeriods: hasPeriods,
        key: drawEvent.eventNumber,
        outcomePairGroups: (outcomePairs === null || outcomePairs === void 0 || (_outcomePairs$index = outcomePairs[index]) === null || _outcomePairs$index === void 0 ? void 0 : _outcomePairs$index.length) > 0 ? (_groupOutcomePairs = groupOutcomePairs(outcomePairs)) === null || _groupOutcomePairs === void 0 ? void 0 : _groupOutcomePairs[index] : [],
        participants: participants === null || participants === void 0 ? void 0 : participants[index],
        productId: productId
      });
    }
    return React.createElement(PrintableCouponRow, {
      drawEvent: drawEvent,
      hasPeriods: hasPeriods,
      key: drawEvent.eventNumber,
      participants: participants === null || participants === void 0 ? void 0 : participants[index],
      reductions: reductions === null || reductions === void 0 ? void 0 : reductions[index],
      signs: signs === null || signs === void 0 ? void 0 : signs[index]
    });
  }));
};
setGlobal('svs.components.poolBetting.printableCoupon.PrintableCoupon', PrintableCoupon);

 })(window);